import React from 'react'
import FilterBar from '../filter-bar'
// import { DropdownFilter } from '../filters'
import { SimpleSearch } from '../'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette, breakpoints }) => ({
  root: {},
  search: {
    backgroundColor: palette.common.white,
    [breakpoints.up('xs')]: {
      width: '100%',
      maxWidth: 300
    },
    [breakpoints.up('sm')]: {
      width: 300
    }
  }
}))

const PlaylistFilterBar = props => {
  const {
    disabled,
    // counts,
    // sorters,
    values,
    onApply: handleApply,
    onClearAll
  } = props

  const classes = useStyles(props)

  /* eslint-disable react/jsx-key */
  // todo: add back in when the api supports it.
  // const filters = [
  //   <DropdownFilter
  //     name='keywords'
  //     label='Keywords'
  //     options={counts.keywords}
  //     multiple
  //     disabled={disabled}
  //   />
  // ]
  /* eslint-enable react/jsx-key */

  // const sorter = (
  //   <DropdownFilter
  //     name='sort'
  //     options={sorters.map(s => ({ key: s }))}
  //     disabled={disabled}
  //   />
  // )

  const search = (
    <SimpleSearch
      onSearch={value => handleApply({ name: 'search', value })}
      disabled={disabled}
      size='small'
      initialValue={values.search || ''}
      className={classes.search}
    />
  )

  return (
    <FilterBar
      // filters={filters}
      // sorter={sorter}
      search={search}
      values={values}
      onClearAll={onClearAll}
      onApply={handleApply}
      disabled={disabled}
      classes={{ root: classes.root }}
    />
  )
}

export default PlaylistFilterBar
